<template>
    <div class="loader-container" :style="{height}">
        <div class="line-loader">
            <div class="loading-line"></div>
            <div class="loading-line" ></div>
            <div class="loading-line" v-if="!small"></div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        height: { default: '18vh' },
        small: { default: false },
    }
}
</script>

<style>
.loader-container{
    padding: 1rem;
    max-width: 200px;
    margin: 0 auto;
}
.line-loader{
    position: relative;
    top: calc(50% - 1rem);
    min-height: 2rem;
}
.loading-line{
    position: absolute;
    height: 5px;
    border-radius: 50px;
    background-image: linear-gradient(to right, var(--yellow-color) 40%, var(--green-color) 55%);
    background-attachment: fixed;
    
    animation: line-loading 1s ease-in-out 0s infinite alternate forwards;
}

.loading-line:nth-of-type(1){
    top: 0;
}
.loading-line:nth-of-type(2){
    top: 40%;
    animation-delay: .3333s;
}
.loading-line:nth-of-type(3){
    top: 80%;
    animation-delay: .666s;
}
@keyframes  line-loading {
    0%{
        left: 0;
        width: 5%;
    }
    50%{
        width: 30%;
    }
    100%{
        width: 5%;
        left: 95%;
    }
}
</style>